export enum FormQuestionType {
  TEXT = 'TEXT',
  CHOICE = 'CHOICE',
  NUMBER = 'NUMBER',
  DATE = 'DATE',
  RATING = 'RATING',
}

export interface FormOption {
  formOptionId: number;
  label: string;
}

export interface FormQuestion {
  formQuestionId: number;
  type: FormQuestionType;
  label: string;
  mandatory: boolean;
  options?: FormOption[];
  meta?: {
    maxAnswers?: number;
    min?: number;
    max?: number;
    scale?: number;
  } | null;
}

export interface UserSummary {
  userId: number;
  firstName: string;
  lastName: string;
  picture?: string;
}

export interface FormResponseAnswer {
  formResponseAnswerId: number;
  questionId: number;
  optionId?: number | null;
  text?: string | null;
}

export interface FormResponse {
  formResponseId: number;
  userId: number;
  user: UserSummary;
  answers: FormResponseAnswer[];
  createdAt: string;
}

export interface Form {
  id: string;
  communityId: number;
  title: string;
  description?: string | null;
  deadline?: string | null;
  questions: FormQuestion[];
  responses: FormResponse[];
  createdBy?: UserSummary;
  createdAt: string;
  resultsVisibility?: 'PUBLIC' | 'PRIVATE';
  participants?: Array<{ dashboardMemberId: number; type: string; userId?: number }>;
  _count?: { responses?: number; questions?: number };
  responsesHidden?: boolean;
}

export interface SubmitFormAnswerDto {
  questionId: number;
  response?: string | null;
  optionId?: number | null;
  optionIds?: number[] | null;
}

export interface SubmitFormBody {
  userId: number;
  answers: SubmitFormAnswerDto[];
}
